<template>
  <div class="add-pay-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="480px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="110px"
        :label-position="labelPosition"
      >
        <el-form-item label="封面图:" prop="cover">
          <base-upload
            class="upload"
            :cover="params.cover"
            :key="params.cover"
            :action="action"
            :wSize="180"
            :hSize="90"
            :width="'180px'"
            :height="'90px'"
            @successCallback="handleAvatarSuccess"
          ></base-upload>
        </el-form-item>
        <el-form-item label="名称:" prop="title">
          <el-input v-model="params.title" placeholder="请填写标题" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="说明:" prop="desc">
          <el-input
            type="textarea"
            v-model="params.desc"
            placeholder="请填写描述"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序:" prop="sort">
          <el-input v-model="params.sort" size="medium" placeholder="请填写排序"></el-input>
        </el-form-item>
        <el-form-item label="跳转方式:" prop="jumpType">
          <el-select v-model="params.jumpType" @change="handleChange">
            <el-option
                label="请选择"
                :value="-1"
                key="-1"
            ></el-option>
            <el-option
              v-for="(item, idx) in jumpList"
              :label="item.label"
              :value="idx"
              :key="idx"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接地址:" prop="jumpLink" v-if="params.jumpType > -1">
          <el-input v-model="params.jumpLink" size="medium" placeholder="请填写链接地址"></el-input>
        </el-form-item>
        <el-form-item label="是否启用:" prop="status">
          <el-select v-model="params.status">
            <el-option
              v-for="(item, idx) in statusList"
              :label="item.label"
              :value="item.value"
              :key="idx"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import {validatorIndex} from "@/utils/validator";
import baseConfig from "@/utils/serverUrlConfig";
import {JUMPLIST} from "@/utils/constants.js";

export default {
  data() {
    return {
      dialogVisible: false,
      labelPosition: "left",
      title: "",
      flag: false,
      id: "",
      type: "",
      jumpList: JUMPLIST,
      statusList: [
        {label: '是', value: 1},
        {label: '否', value: 0},
      ],
      params: {
        id: "",
        cover: "", //图片
        title: "", //名称
        desc: "", //说明
        sort: 0, //排序
        jumpType: 0, //跳转类型
        jumpLink: "", //跳转地址
        status: 1, //启用状态
      },
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      rules: {
        title: [{ required: true, message: "请填写名称", trigger: "blur" }],
        sort: [
          { required: true, message: "请填写排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择开关状态", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    handleChange(val){
      //  =
      this.params.jumpLink = this.jumpList[val].value
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addProduct();
          } else {
            this.editProduct();
          }
        } else {
          return false;
        }
      });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        id: "",
        cover: "", //图片
        title: "", //名称
        desc: "", //说明
        sort: 0, //排序
        jumpType: 0, //跳转类型
        jumpLink: "", //跳转地址
        status: 1, //启用状态
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑金刚区配置";
        this.params.id = data.id;
        this.params.cover = data.cover;
        this.params.desc = data.desc;
        this.params.title = data.title;
        this.params.sort = data.sort;
        this.params.jumpType = data.jumpType;
        this.params.jumpLink = data.jumpLink;
        this.params.status = data.status;
      } else {
        this.title = "新增金刚区配置";
        this.params.id = "";
        this.params.cover = "";
        this.params.desc = "";
        this.params.title = "";
        this.params.sort = "";
        this.params.jumpType = null;
        this.params.jumpLink = null;
        this.params.status = 1;
      }
    },
    // 新增
    addProduct() {
      this.params.sort = Number(this.params.sort)
      API.addJGConfig(this.params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("handlerProductList");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    handleAvatarSuccess(res) {
      this.params.cover = res.data.coverImg;
    },
    // 编辑
    editProduct() {
      let form = Object.assign(this.params);
      this.params.sort = Number(this.params.sort)

      API.editJGConfig(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("handlerProductList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
  },
};
</script>

<style lang="scss">
.add-pay-box {
  .el-select,
  .el-input {
    width: 100%;
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
